export function isTrackingAvailable(): boolean {
    const g = globalThis as typeof globalThis & {
        _uxa?: unknown[];
        hj?: (...arguments_: unknown[]) => void;
    };

    return (
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        g !== undefined &&
        "_uxa" in g &&
        Array.isArray(g._uxa) &&
        typeof g.hj === "function"
    );
}

/**
 * Tags the current session with multiple tags by pushing named events.
 * This is a replacement for Hotjar's `tagRecording()` using Contentsquare ETR tags.
 *
 * @example
 * tagRecording(["slug_shop", "lang_de"])
 *
 * @param tags - Array of tag strings
 */
export function tagRecording(tags: string[]): void {
    const g = globalThis as typeof globalThis & {
        _uxa?: unknown[];
        hj?: (...arguments_: unknown[]) => void;
    };
    if (!isTrackingAvailable()) return;

    for (const tag of tags) {
        g._uxa?.push(["trackEventTriggerRecording", `@ETS@${tag}`]);
    }
}

/**
 * Tracks a custom session-level event via Contentsquare.
 * Equivalent to Hotjar's `event()` but using the Contentsquare format.
 *
 * @example
 * trackEvent("logo_activated")
 *
 * @param eventName - Event name (snake_case recommended)
 */
export function trackEvent(eventName: string): void {
    if (!isTrackingAvailable()) return;

    const g = globalThis as typeof globalThis & {
        _uxa?: unknown[];
        hj?: (...arguments_: unknown[]) => void;
    };

    g._uxa?.push(["trackPageEvent", `@ETS@${eventName}`]);
}
